import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import AddButton from "../buttons/button";
import CloseIcon from "../../assets/icons/close-icon";
import LoadingOverlay from "../helper-components/overlay-loading";
import { useFormikContext } from "formik";
import ItemsSearchAddFeild from "../forms/items-search-add-field";
import {
  productListAction,
  storeCityListAction,
  storeDistrictListAction,
  storeStateListAction,
  storesItemAction,
} from "../../redux/actions/general-action";
import { useDispatch } from "react-redux";
import ItemsSelectField from "../forms/items-select-field";
import ItemsInputField from "../forms/items-input-field";
import { useNavigate } from "react-router-dom";
import { truncateString } from "../helper-components/helper-function";

export default function BillingOtherStores({ open, setOpen, selectedItem }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [localData, setLocalData] = useState([]);
  const { values, setFieldValue } = useFormikContext();
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const fetchData = async (inputValue, callback, field) => {
    const onSuccess = (data) => {
      const rows = (data?.data ?? []).map((item) => ({
        value: item.item_id,
        label: item.item_name,
      }));
      setLocalData(data.data);
      callback(rows);
    };

    const onError = () => {};

    if (inputValue?.length > 0) {
      dispatch(
        productListAction(
          {
            field: field,
            value: inputValue,
          },
          onSuccess,
          onError
        )
      );
    }
  };

  useEffect(() => {
    if (open) {
      setFieldValue(`otherStores.item_id`, selectedItem?.itemid);
      setFieldValue(`otherStores.item_name`, selectedItem?.item_name);
      dispatch(storeStateListAction(onStateSuccess, onStateError));
      dispatch(storeDistrictListAction({}, onDistrictSuccess, onDistrictError));
      dispatch(storeCityListAction({}, onCitySuccess, onCityError));
    }
  }, [open]);
  const onStateSuccess = (data) => {
    setStateList(
      data?.data?.map((state, index) => ({
        label: state?.firm_state,
        value: state?.firm_state,
      }))
    );
  };
  const onStateError = (data) => {
    setStateList([]);
  };
  const onDistrictSuccess = (data) => {
    setDistrictList(
      data?.data?.map((state, index) => ({
        label: state?.firm_district,
        value: state?.firm_district,
      }))
    );
  };
  const onDistrictError = (data) => {
    setDistrictList([]);
  };
  const onCitySuccess = (data) => {
    console.log(data, "gsdfgfdgdfgdfgfdg");

    setCityList(
      data?.data?.map((state, index) => ({
        label: state?.firm_city,
        value: state?.firm_city,
      }))
    );
  };
  const onCityError = (data) => {
    setCityList([]);
  };
  useEffect(() => {
    if (open) {
      dispatch(
        storesItemAction(
          {
            item_id: values?.otherStores?.item_id || selectedItem?.itemid || "",
            state: values?.otherStores?.state || "",
            district: values?.otherStores?.district || "",
            city: values?.otherStores?.city || "",
          },
          onSuccess,
          onError
        )
      );
    }
  }, [
    values?.otherStores?.item_id,
    values?.otherStores?.state,
    values?.otherStores?.district,
    values?.otherStores?.city,
  ]);

  const onSuccess = (data) => {
    setFieldValue(`otherStores.items`, data?.data);
  };
  const onError = (data) => {
    setFieldValue(`otherStores.items`, []);
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => {
          setOpen(false);
        }}
      >
        <div className="fixed inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-[#0000004D]" />
          </Transition.Child>

          <div className="fixed inset-0 flex justify-end">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-300"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-300"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <Dialog.Panel className="h-full w-[400px] sm:w-[80%] bg-white overflow-y-auto rounded-tl-lg rounded-bl-lg shadow-xl">
                <div
                  className="h-[61px] bg-[var(--slide-panel-head-bg)] px-3 flex items-center justify-between border-b"
                  style={{ borderColor: "var(--slide-panel-border)" }}
                >
                  <div
                    style={{
                      maxHeight: "32px",
                      color: "var(--slide-panel-h-fg)",
                      fontSize: "var(--slide-panel-h-fs)",
                      fontWeight: "var(--slide-panel-h-fw)",
                    }}
                    className="min-w-[75%] "
                  >
                    Other Stores
                  </div>
                  <AddButton
                    onclkFn={() => {
                      setOpen(false);
                    }}
                    icon={
                      <CloseIcon
                        width="12px"
                        height="12px"
                        fill="var(--close-button-fg)"
                      />
                    }
                    text={
                      <span>
                        Close <span className="opacity-50">(X)</span>{" "}
                      </span>
                    }
                    className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                  />
                </div>
                <div
                  className="px-3 "
                  style={{
                    maxHeight: `calc(100% - 115px)`,
                    minHeight: `calc(100% - 115px)`,
                    height: `calc(100% - 115px)`,
                  }}
                >
                  <div className="flex flex-wrap items-center justify-between gap-x-3 h-[5.5rem]">
                    <div className="w-[22%] h">
                      <ItemsSearchAddFeild
                        useDefaultStyles={true}
                        defaultOptions={values?.data?.map((item) => ({
                          label: item.item_name,
                          value: item.item_id,
                        }))}
                        label={"Select Or Search product"}
                        isDisabled={false}
                        isLabelReq={true}
                        menuPlacement="auto"
                        optionPadding={0}
                        menuWidth="45rem"
                        errorClass="hidden"
                        isRequired={false}
                        value={
                          values?.otherStores?.item_id
                            ? {
                                label: values.otherStores.item_name,
                                value: values.otherStores.item_id,
                              }
                            : null
                        }
                        name={`otherStores.item_name`}
                        field={"item_name"}
                        defaultSelectClass=""
                        placeholder={"Select Or Search product"}
                        fetchData={fetchData}
                        onChange={async (selectedOption) => {
                          console.log(selectedOption, "gdsfsfsdfdsfsfs");
                          if (!selectedOption) return;

                          const foundItem = localData?.find(
                            (item) => item.item_id === selectedOption.value
                          );

                          setFieldValue(
                            "otherStores.item_id",
                            selectedOption.value
                          );
                          setFieldValue(
                            "otherStores.item_name",
                            selectedOption.label
                          );
                        }}
                      />
                    </div>
                    <div className="w-[18%]">
                      <ItemsSelectField
                        options={stateList}
                        name={`otherStores.state`}
                        label="State"
                        isLabelReq={true}
                        placeholder="All State"
                      />
                    </div>
                    <div className="w-[18%]">
                      <ItemsSelectField
                        label="District"
                        options={districtList}
                        name={`otherStores.district`}
                        isLabelReq={true}
                        placeholder="All Districts"
                      />
                    </div>
                    <div className="w-[18%]">
                      <ItemsSelectField
                        label="City"
                        options={cityList}
                        name={`otherStores.city`}
                        isLabelReq={true}
                        placeholder="All Cities"
                      />
                    </div>
                    <div className="w-[18%]">
                      <ItemsInputField
                        name={`tempRowData.store_search`}
                        label="Search Store"
                        isLabelReq={true}
                        placeholder="Search Store name or code"
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      maxHeight: `calc(100% - 6rem)`,
                      minHeight: `5rem`,
                    }}
                    className="tab-container rounded-[8px] "
                  >
                    <table className="w-full border-collapse mt-0">
                      <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                        <tr className="relative h-[50px] rounded-lg">
                          {heading
                            .filter((col) => col.enabled !== false)
                            .map((col, idx) => (
                              <th
                                style={{ minWidth: `${col?.minWidth}px` }}
                                key={idx}
                                className="px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]"
                              >
                                <div
                                  className="flex items-center gap-2 w-full text-wrap"
                                  style={{
                                    justifyContent:
                                      col?.alignment === "right"
                                        ? "flex-end"
                                        : col?.alignment === "center"
                                        ? "center"
                                        : "flex-start",
                                  }}
                                >
                                  {col?.label}
                                </div>
                              </th>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {values.otherStores.items?.filter((store) => {
                          const search = values.tempRowData?.store_search
                            ?.toLowerCase()
                            .trim();
                          if (!search) return true;
                          return (
                            store.store_code?.toLowerCase().includes(search) ||
                            store.store_name?.toLowerCase().includes(search)
                          );
                        })?.length > 0 ? (
                          <>
                            {" "}
                            {values.otherStores.items
                              ?.filter((store) => {
                                const search = values.tempRowData?.store_search
                                  ?.toLowerCase()
                                  .trim();
                                if (!search) return true;
                                return (
                                  store.store_code
                                    ?.toLowerCase()
                                    .includes(search) ||
                                  store.store_name
                                    ?.toLowerCase()
                                    .includes(search)
                                );
                              })
                              ?.map((batch, index) => (
                                <tr
                                  key={batch.item_batch_number || index}
                                  className={`cursor-pointer transition-all  ${
                                    index % 2 === 0
                                      ? " bg-[var(--create-table-row-alt-bg)]"
                                      : " bg-[var(--create-table-row-bg)]"
                                  }   h-[48px]`}
                                >
                                  {heading
                                    .filter((col) => col.enabled !== false)
                                    .map((col, colIndex) => (
                                      <td
                                        style={{
                                          minWidth: `${col?.minWidth}px`,
                                          textAlign: col?.alignment, // Keep textAlign for normal text cells
                                        }}
                                        key={colIndex}
                                        className="border-b border-[var(--create-table-border)] px-[8px] text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)]  whitespace-nowrap cursor-pointer"
                                      >
                                        {col?.value === "stock_status" ? (
                                          <div className="flex items-center gap-2">
                                            <span
                                              className={`text-[var(--pill-badge-text-color)] text-[length:var(--pill-badge-fs)] font-[var(--pill-badge-fw)] px-3 py-1 border-radius ${
                                                batch[col.value] === "In Stock"
                                                  ? "bg-[var(--pill-badge-green-bg)]"
                                                  : batch[col.value] ===
                                                    "Out of Stock"
                                                  ? "bg-[var(--pill-badge-red-bg)]"
                                                  : "bg-[var(--pill-badge-yellow-bg)]"
                                              }`}
                                            >
                                              {batch[col.value]}
                                            </span>
                                          </div>
                                        ) : col?.value === "action" ? (
                                          <AddButton
                                            prefixIcon={false}
                                            text={"Transfer Request"}
                                            className="flex items-center px-[15px] h-[35px] whitespace-nowrap rounded-md gap-[8px]
                    bg-[var(--primary-button-bg-color)] cursor-pointer
                    text-[var(--primary-button-fg-color)]
                    border border-[var(--primary-button-bg-color)]
                    hover:bg-[var(--primary-button-hover-color)]
                    text-[length:var(--primary-button-font-size)] 
                    font-[var(--primary-button-font-weight)]"
                                            type="button"
                                            onclkFn={() => {
                                              navigate("/add-stock-transfer");
                                            }}
                                          />
                                        ) : (
                                          truncateString(
                                            batch[col.value] || "",
                                            100
                                          ) ?? "--"
                                        )}
                                      </td>
                                    ))}
                                </tr>
                              ))}
                          </>
                        ) : (
                          <tr>
                            <td
                              colSpan={
                                heading?.filter((h) => h?.enabled !== false)
                                  .length
                              }
                              className="text-center py-4 text-[length:var(--tab-empty-comp-fs)] border-b border-[var(--create-table-border)] font-[var(--tab-empty-comp-fw)] text-[var(--tab-empty-comp-fg)]"
                            >
                              No stores found for the selected criteria.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="flex justify-between h-[50px] items-center px-3">
                  <AddButton
                    prefixIcon={false}
                    onclkFn={() => {
                      setOpen(false);
                    }}
                    text={
                      <span>
                        Cancel <span className="opacity-50">(C)</span>{" "}
                      </span>
                    }
                    className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                  />
                </div>

                <LoadingOverlay />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

const heading = [
  { label: "Store Code", value: "store_code" },
  { label: "Store Address", value: "store_address" },
  { label: "Store Type", value: "store_type" },
  { label: "Expiry Status", value: "expiry_status" },
  { label: "Stock Status", value: "stock_status" },
  { label: "MRP Range", value: "max_mrp_range" },
  { label: "Sale Rate Range", value: "sale_rate_range" },
  { label: "Available Qty", value: "available_qty" },
  { label: "No. of Batches", value: "batch_count" },
  { label: "Action", value: "action" },
];
